module.exports = __webpack_public_path__ + "img/linketree_dark.a4ad92a9.png";